<template>
  <div class="main-wrap">
    <div class="header">
      <div class="title">
        <span class="title-text">
          <img v-if="scoolLogo" style="height: 60px; width: 60px; margin-bottom: -12px; margin-right: -20px; " :src="scoolLogo" />
          {{scoolName}}
        </span>
      </div>
      <div class="status-text">{{noticeText}}</div>
      <div class="datetime-block">
        <div class="time">
          <img src="@/assets/images/time.png" alt />
          {{dateTimeObj.currentTime}}
        </div>
        <span class="date">{{dateTimeObj.currentDate}}</span>
      </div>
    </div>
    <div class="zzfx">
      <span class="zzfx-title">正在放学</span>
      <div class="zzfx-classes">
        <el-carousel height="50px" direction="vertical" :autoplay="true" indicator-position="none">
          <el-carousel-item v-for="(arr,index) of fxzhong2DimArr" :key="index">
            <div
              style="display:flex; justify-content:space-around; align-items: center;height:50px"
            >
              <span v-for="(item,i) of arr" :key="i">{{ item.className }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="bjxx">
      <img src="@/assets/images/bjxx.png" alt />
      <span class="bjxx-text">班级信息</span>
      <img src="@/assets/images/icon-001.png" alt />
    </div>

    <div class="content">
      <div class="content-flex">
        <div
          :class="['hang', i%2==0 ? 'hang1' : 'hang2']"
          v-for="(arr,i) of classesArrPage"
          :key="i"
        >
          <span
            :style="{color: item.leaveStatus == 0 ? '#fc1100' : item.leaveStatus == 1 ? '#fc5de1' : '#3af95a' }"
            class="item"
            v-for="item of arr"
            :key="item.id"
          >{{item.className}}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="item" style="justify-content: flex-end;">
        <div class="yuan" style="background: #fc1100"></div>
        <span style="color:#fc1100">红色代表未放学</span>
      </div>
      <div class="item" style="justify-content: center;">
        <div class="yuan" style="background: #fc5de1"></div>
        <span style="color:#fc5de1">粉色代表放学中</span>
      </div>
      <div class="item" style="justify-content: flex-start;">
        <div class="yuan" style="background: #3af95a"></div>
        <span style="color:#3af95a">绿色代表已放学</span>
      </div>
    </div>
    <!-- <button @click="play()">播报语音</button>
    <button @click="cancel()">取消播报</button>
    <button @click="pause()">暂停播报</button>
    <button @click="resume()">恢复播报</button>
    <button @click="clear()">清除数据</button>
    <button @click="resetData()">恢复数据</button>-->
  </div>
</template>

<script>
import myMixin from "./mixin/index.js";
import { listBySchoolNo } from "@/api/api.js";

export default {
  mixins: [myMixin],
  data() {
    return {
      // screen2中需要用到的
      arr3dim: [], // 多页的班级_三维数组
      classesArrPage: [], // 一页的班级_二级数组
      isRunIntervalPage: false, // 是否跑起了翻页
      pageIndex: 0, // 当前页索引

      fxzhong2DimArr: [], // 放学中的二维数组
    };
  },
  methods: {
    // 获取该学校的所有班级信息，然后处理数据——选择【播放模式】
    getListBySchoolNo(playMode) {
      return listBySchoolNo({
        schoolNo: this.schoolNo,
      }).then((res) => {
        this.weifxArr = res.data.filter((item) => item.leaveStatus == 0);
        let newArr = res.data.filter((item) => item.leaveStatus == 1);
        newArr.sort(function (a, b) {
          if (a.updateTime < b.updateTime) {
            // 按某种排序标准进行比较, a 小于 b
            return -1;
          } else if (a.updateTime > b.updateTime) {
            return 1;
          } else {
            return 0;
          }
        });
        this.fxzhongArr = newArr;

        this.yifxArr = res.data.filter((item) => item.leaveStatus == 2);
        this.totalNum = res.data.length;
        this.changeNotice();

        // screen2中新增的处理
        this.dealData(res.data);

        if (playMode == "continuousPlay") {
          this.continuousPlay();
        } else if (playMode == "numberPlay") {
          this.numberPlay();
        } else {
          console.log("播放模式错误！");
        }
      });
    },

    dealData(data) {
      let arr2dim = []; // 全部的二维数组
      for (let i = 0; i < data.length / 6; i++) {
        arr2dim.push(data.slice(i * 6, (i + 1) * 6));
      }
      this.arr3dim = [];
      for (let i = 0; i < arr2dim.length / 6; i++) {
        this.arr3dim.push(arr2dim.slice(i * 6, (i + 1) * 6));
      }
      console.log(this.arr3dim);

      this.classesArrPage = this.arr3dim[this.pageIndex];

      // 每隔5秒换到下一页
      if (!this.isRunIntervalPage && this.arr3dim.length > 1) {
        this.isRunIntervalPage = true;
        let interval1 = setInterval(() => {
          this.pageIndex++;
          this.pageIndex = this.pageIndex % this.arr3dim.length
          this.classesArrPage =
            this.arr3dim[this.pageIndex];
        }, 5000);

        this.$once("hook:beforeDestroy", () => {
          clearInterval(interval1);
        });
      }

      // 更新放学中的数组
      this.fxzhong2DimArr = [];
      for (let i = 0; i < this.fxzhongArr.length / 6; i++) {
        this.fxzhong2DimArr.push(this.fxzhongArr.slice(i * 6, (i + 1) * 6));
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@mixin hvCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-wrap {
  width: 100vw;
  height: 100vh;
  background: url("~@/assets/images/第二版背景.png") no-repeat center;
  background-size: 100% 100%;

  .header {
    height: 20%;
    // border: greenyellow 1px solid;

    .title {
      height: 40%;
      @include hvCenter();
      font-size: 6rem;
      color: white;
      letter-spacing: 2rem;
    }

    .status-text {
      color: #ffdf40;
      font-size: 4.5rem;
      @include hvCenter();
    }

    .datetime-block {
      color: #fff;
      font-size: 3.3rem;
      text-align: right;
      position: relative;
      bottom: 1vh;
      right: 7rem;

      .time {
        position: absolute;
        top: -140%;
        right: 0;
        @include hvCenter();
        img {
          width: 3rem;
          height: 3rem;
          margin-right: 1rem;
        }
      }
    }
  }

  .zzfx {
    width: 100%;
    height: 8%;
    background: url("~@/assets/images/zzfx_bg.png") no-repeat center;
    background-size: 95% 100%;
    // border: 1px solid red;
    margin-top: 1%;
    color: #fc5de1;
    font-size: 4rem;

    @include hvCenter();

    .zzfx-title {
      width: 18.5%;
      padding-left: 5.5%;
    }
    .zzfx-classes {
      width: 81.5%;
      height: 100%;
      // border: 1px solid red;
      padding-top: 0.8%;
      padding-right: 5%;
    }
  }

  .bjxx {
    height: 10%;
    // border: 1px solid greenyellow;
    padding: 0 2.5%;
    display: flex;
    align-items: center;

    .bjxx-text {
      color: #00e6ff;
      font-size: 4rem;
      margin: 0 1%;
    }

    img:nth-of-type(1) {
      width: 4rem;
      height: 4rem;
    }
    img:nth-of-type(2) {
      height: 2rem;
      margin-left: 2rem;
    }
  }

  .content {
    height: 54%;

    @include hvCenter();
    .content-flex {
      width: 95%;
      height: 100%;
      // border: hotpink 1px solid;
      background: url("~@/assets/images/content-bg.png") no-repeat center;
      background-size: 100% 100%;
      padding: 1.5%;

      .hang {
        height: 16.66%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 4.5rem;
        .item {
          width: 16.66%;
          text-align: center;
        }
      }
      .hang1 {
        background: #041d49;
      }
      .hang2 {
        background: #032c62;
      }
    }
  }

  .footer {
    font-size: 3.5rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 5.9%;

    .item {
      width: 30%;
      display: flex;

      align-items: center;

      .yuan {
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
        margin-right: 2rem;
      }
    }
  }
}
</style>
